<template>
  <div class="login">
    <div class="author-top">
      <p>河北《教育实践与研究》杂志社</p>
      <span>编辑端</span>
    </div>
    <div class="author-middle">
      <div class="middle-box">
        <p></p>
        <login />
      </div>
    </div>
    <div class="author-bottom"></div>
    <input id="userType" type="hidden" value="2" />
  </div>
</template>
<script>
import Login from './../components/Login';
export default {
  name: 'EditLogin',
  components: {
    login: Login
  },
  data() {
    return {};
  },
  methods: {
    handleCancel() {}
  }
};
</script>
<style>
.login {
  width: 100%;
  height: 100vh;
  background-color: #0955d2;
}
.login .author-top {
  width: 100%;
  background: #0955d2;
  text-align: center;
  padding-top: 6%;
}
.login .author-top img {
  margin-top: 2%;
  height: 120px;
  width: 140px;
}
.login .author-top p {
  color: #ffffff;
  font-size: 48px;
  font-family: '微软雅黑';
  margin: 0;
}
.login .author-top span {
  color: #ffffff;
  font-size: 24px;
}
.login .author-middle {
  background: #0955d2;
  width: 100%;
  padding: 40px;
}
.login .author-middle .middle-box {
  width: 420px;
  height: 330px;
  background: #ffffff;
  margin: 0 auto;
  border-radius: 10px;
  text-align: center;
  box-shadow: rgb(199, 196, 196) 18px 20px 10px 0;
}
.login .author-middle .middle-box p {
  font-size: 28px;
  padding-top: 40px;
  font-family: '微软雅黑';
  color: #333333;
}
.login .author-bottom {
  width: 100%;
  background: #0955d2;
  bottom: 0;
}
.login .author-middle .middle-box .login-com .com-sign {
  display: none;
}
.login-com .com-btn .ant-btn-default {
  width: 364px;
  height: 50px;
  background: #005bcd;
  margin-top: 40px;
}
.login-com .com-btn .ant-btn-default span {
  font-size: 18px;
  color: #ffffff;
}
.com-password {
  display: none;
}
</style>


